import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FaefStateService } from './../faef-state.service';
export class ComprasTrimestreComponent {
    constructor(fb, state) {
        this.fb = fb;
        this.state = state;
        this.next = new EventEmitter();
        this.previous = new EventEmitter();
    }
    ngOnInit() {
        this.createForms();
        const faef = this.state.getLast();
        if (faef.faefCompras) {
            this.compraForm.patchValue(faef.faefCompras, { emitEvent: false });
        }
    }
    createForms() {
        this.compraForm = this.fb.group({
            comprasAUmMes: ['', Validators.required],
            comprasADoisMeses: ['', Validators.required],
            comprasATresMeses: ['', Validators.required],
            percentualComprasAVista: ['', [Validators.required, Validators.max(100), Validators.min(0)]]
        });
    }
    updateState() {
        const faef = this.state.getLast();
        const faefCompras = this.compraForm.value;
        faef.faefCompras = {
            comprasAUmMes: Number(faefCompras.comprasAUmMes),
            comprasADoisMeses: Number(faefCompras.comprasADoisMeses),
            comprasATresMeses: Number(faefCompras.comprasATresMeses),
            percentualComprasAVista: Number(faefCompras.percentualComprasAVista)
        };
        this.state.setState(faef);
    }
    onClickNext() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.updateState();
            this.next.emit();
        });
    }
    onClickPrevious() {
        this.updateState();
        this.previous.emit();
    }
}
